import React from "react";
import "./fleekhauz.scss";
import data from "../../data.json";
import Heroc from "../../../component/hero/heroc.jsx";
import Aboutc from "../../../component/about/aboutc.jsx";
import Heroimages from "../../../asset/hero/heroimages.js";
import Promoc from "../../../component/promo/promoc.jsx";
import hsimages from "../../../asset/hardsell/hsimages.js";
import prmo from "../../../component/promo/promocard.json";
import Carouselfasc from "../../../component/carouselfas/carouselfasc.jsx";
import fas from "../../../component/carouselfas/carouselfasc.json";
import fasfleekhauz from "../../../asset/fascarousel/fas-yuthica/fas-yuthica.js";
import dataproduk from "../../../component/cardprodukdetail/cardprodukdetail.json";
import Cardprodukdetail from "../../../component/cardprodukdetail/cardprodukdetail.jsx";
import imgFleekhauz from "../../../asset/imgrumah/img-fleekhauz/img-fleekhauz.js";
const imgMap = {
  fasfleekhauz,
};
const imageMap = {
  imgFleekhauz,
};

const fleekhauz = () => {
  return (
    <div className="fleekhauz">
      <div className="hero">
        {data.fleekhauzab.map((hero, index) => {
          // Determine the logo dynamically
          const fotopromo = Heroimages[hero.imagehero];
          return (
            <Heroc
              key={index}
              imagehero={fotopromo} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="about">
        {data.fleekhauzab.map((home, index) => {
          // Determine the logo dynamically
          return (
            <Aboutc
              key={index}
              judul={home.judul}
              subjudul={home.subjudul} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="container-promo">
        {prmo.Fleekhauz.map((promo, index) => {
          // Determine the logo dynamically
          const fotopromo = hsimages[promo.imagehs];
          return (
            <Promoc
              key={index}
              imagehs={fotopromo} // Dynamically import logo images
              titlepromo={promo.titlepromo}
              details={promo.details}
              whatsappLink={promo.whatsappLink}
              quote={promo.quote} // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="carouselfas">
        {fas.fasFleekhauz.map((slide, index) => {
          return <Carouselfasc key={index} carousel={imgMap[slide.carousel]} />;
        })}
      </div>
      <div className="produkcontainer">
        {dataproduk.Fleekhauzp.map((card, index) => {
          return (
            <Cardprodukdetail
              key={index}
              src={imageMap[card.imagesKey]}
              title={card.title}
              sub={card.sub}
              subt={card.subt}
              details={card.details}
              price={card.price}
              whatsappLink={card.whatsappLink}
            />
          );
        })}
      </div>
    </div>
  );
};

export default fleekhauz;
